export default __webpack_public_path__ + "static/media/img_artwork_canal_no_image.c1a2dd1b.svg";